<!-- B04 机构员工/师傅管理（B4） + W4-3 邀请码 -->
<template>
  <div>
    <el-tabs v-model="activeTab" class="mb-12px">
      <el-tab-pane label="员工列表" name="provider" />
      <el-tab-pane label="邀请码" name="invite" />
    </el-tabs>

    <el-card v-show="activeTab === 'provider'" shadow="never">
      <el-form ref="queryFormRef" :inline="true" :model="queryParams" class="-mb-15px" label-width="68px">
        <el-form-item label="姓名" prop="realName">
          <el-input
            v-model="queryParams.realName"
            class="!w-220px"
            clearable
            placeholder="请输入姓名"
            @keyup.enter="handleQuery"
          />
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input
            v-model="queryParams.mobile"
            class="!w-220px"
            clearable
            placeholder="请输入手机号"
            @keyup.enter="handleQuery"
          />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="queryParams.status" class="!w-220px" clearable placeholder="全部">
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">
            <Icon class="mr-5px" icon="ep:search" />搜索
          </el-button>
          <el-button @click="resetQuery">
            <Icon class="mr-5px" icon="ep:refresh" />重置
          </el-button>
        </el-form-item>
      </el-form>

      <el-alert
        class="mb-16px"
        :closable="false"
        show-icon
        title="员工通过 S 端邀请码加入，平台审核通过后出现在本列表；机构可暂停/恢复接单，不可新建或封禁。"
        type="info"
      />

      <el-table v-loading="loading" :data="list" stripe>
        <el-table-column label="姓名" min-width="100" prop="realName" />
        <el-table-column label="手机号" width="130" prop="mobile" />
        <el-table-column label="认证等级" width="100" align="center">
          <template #default="{ row }">L{{ row.authLevel ?? 0 }}</template>
        </el-table-column>
        <el-table-column label="评分" width="80" align="center" prop="ratingAvg" />
        <el-table-column label="完成单量" width="100" align="center" prop="completedOrders" />
        <el-table-column label="状态" width="100" align="center">
          <template #default="{ row }">
            <el-tag :type="statusTagType(row.status)" size="small">{{ statusLabel(row.status) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="加入时间" width="170" prop="createTime" :formatter="dateFormatter" />
        <el-table-column label="操作" width="250" fixed="right">
          <template #default="{ row }">
            <el-button link type="primary" @click="openDetail(row.id)">详情</el-button>
            <el-button link type="primary" @click="capabilityRef?.open(row)">能力/排班</el-button>
            <el-button
              v-if="canToggleStatus(row)"
              link
              :type="row.status === 'ACTIVE' ? 'warning' : 'success'"
              @click="handleToggleStatus(row)"
            >
              {{ row.status === 'ACTIVE' ? '暂停接单' : '恢复接单' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <Pagination
        v-model:limit="queryParams.pageSize"
        v-model:page="queryParams.pageNo"
        :total="total"
        @pagination="getList"
      />
    </el-card>

    <el-card v-show="activeTab === 'invite'" shadow="never">
      <div class="mb-16px flex items-center justify-between">
        <el-alert
          class="flex-1 mr-16px"
          :closable="false"
          show-icon
          title="生成邀请码后发给待加入员工；员工在 S 端注册时选择「机构员工」并填写邀请码。每个码一次性有效，默认 7 天过期。"
          type="info"
        />
        <el-button type="primary" @click="openCreateInviteDialog">
          <Icon class="mr-5px" icon="ep:plus" />生成邀请码
        </el-button>
      </div>

      <el-form :inline="true" :model="inviteQueryParams" class="-mb-15px" label-width="68px">
        <el-form-item label="状态">
          <el-select v-model="inviteQueryParams.status" class="!w-220px" clearable placeholder="全部">
            <el-option
              v-for="item in inviteStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleInviteQuery">
            <Icon class="mr-5px" icon="ep:search" />搜索
          </el-button>
        </el-form-item>
      </el-form>

      <el-table v-loading="inviteLoading" :data="inviteList" stripe>
        <el-table-column label="邀请码" width="120" prop="code">
          <template #default="{ row }">
            <span class="invite-code">{{ row.code }}</span>
            <el-button class="ml-8px" link type="primary" @click="copyCode(row.code)">复制</el-button>
          </template>
        </el-table-column>
        <el-table-column label="目标手机" width="130" prop="targetMobile">
          <template #default="{ row }">
            {{ row.targetMobile || '—' }}
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100" align="center">
          <template #default="{ row }">
            <el-tag :type="inviteStatusTagType(row.status)" size="small">
              {{ inviteStatusLabel(row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="使用人" min-width="120">
          <template #default="{ row }">{{ row.usedByProviderName || '—' }}</template>
        </el-table-column>
        <el-table-column label="创建时间" width="170" prop="createTime" :formatter="dateFormatter" />
        <el-table-column label="过期时间" width="170">
          <template #default="{ row }">{{ formatDateTime(row.expireTime) }}</template>
        </el-table-column>
        <el-table-column label="使用时间" width="170">
          <template #default="{ row }">{{ formatDateTime(row.usedTime) }}</template>
        </el-table-column>
      </el-table>

      <Pagination
        v-model:limit="inviteQueryParams.pageSize"
        v-model:page="inviteQueryParams.pageNo"
        :total="inviteTotal"
        @pagination="getInviteList"
      />
    </el-card>

    <el-drawer v-model="detailVisible" :title="detailTitle" size="520px">
      <div v-loading="detailLoading">
        <template v-if="detail">
          <el-descriptions :column="1" border>
            <el-descriptions-item label="姓名">{{ detail.realName }}</el-descriptions-item>
            <el-descriptions-item label="手机号">{{ detail.mobile }}</el-descriptions-item>
            <el-descriptions-item label="性别">{{ genderLabel(detail.gender) }}</el-descriptions-item>
            <el-descriptions-item label="状态">
              <el-tag :type="statusTagType(detail.status)" size="small">{{ statusLabel(detail.status) }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="认证等级">L{{ detail.authLevel ?? 0 }}</el-descriptions-item>
            <el-descriptions-item label="平均评分">{{ detail.ratingAvg ?? '—' }}</el-descriptions-item>
            <el-descriptions-item label="完成单量">{{ detail.completedOrders ?? 0 }}</el-descriptions-item>
            <el-descriptions-item label="承诺金">{{ depositLabel(detail.depositStatus) }}</el-descriptions-item>
            <el-descriptions-item label="加入时间">{{ formatDateTime(detail.createTime) }}</el-descriptions-item>
          </el-descriptions>

          <div v-if="canToggleStatus(detail)" class="mt-16px">
            <el-button
              :type="detail.status === 'ACTIVE' ? 'warning' : 'success'"
              @click="handleToggleStatus(detail)"
            >
              {{ detail.status === 'ACTIVE' ? '暂停接单' : '恢复接单' }}
            </el-button>
          </div>
        </template>
      </div>
    </el-drawer>

    <el-dialog v-model="createInviteVisible" title="生成邀请码" width="480px" @closed="resetCreateInviteForm">
      <el-form ref="createInviteFormRef" :model="createInviteForm" :rules="createInviteRules" label-width="100px">
        <el-form-item label="员工手机号" prop="targetMobile">
          <el-input
            v-model="createInviteForm.targetMobile"
            maxlength="11"
            placeholder="待加入员工的手机号"
          />
          <div class="form-tip">不能与机构管理员手机号相同（L18-031）</div>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="createInviteVisible = false">取消</el-button>
        <el-button type="primary" :loading="createInviteSubmitting" @click="submitCreateInvite">生成</el-button>
      </template>
    </el-dialog>

    <el-dialog v-model="createdCodeVisible" title="邀请码已生成" width="420px">
      <div class="created-code-box">
        <div class="created-code">{{ createdCode }}</div>
        <div class="created-code-tip">请复制发送给员工，在 S 端注册时选择「机构员工」并填写此码</div>
      </div>
      <template #footer>
        <el-button @click="createdCodeVisible = false">关闭</el-button>
        <el-button type="primary" @click="copyCode(createdCode)">复制邀请码</el-button>
      </template>
    </el-dialog>
    <ProviderCapabilityScheduleDialog ref="capabilityRef" merchant />
  </div>
</template>

<script setup lang="ts">
import { dateFormatter, formatDate } from '@/utils/formatTime'
import ProviderCapabilityScheduleDialog from '@/views/o2o/provider/ProviderCapabilityScheduleDialog.vue'
import {
  createO2oMerchantInviteCode,
  getO2oMerchantInviteCodePage,
  type O2oInviteCodeMerchantRespVO
} from '@/api/merchant/o2o/invite-code'
import {
  getO2oMerchantProvider,
  getO2oMerchantProviderPage,
  updateO2oMerchantProviderStatus,
  type O2oProviderMerchantRespVO
} from '@/api/merchant/o2o/provider'

defineOptions({ name: 'MerchantO2oProvider' })

const message = useMessage()
const capabilityRef = ref()

const activeTab = ref('provider')

const statusOptions = [
  { label: '待审核', value: 'PENDING' },
  { label: '正常', value: 'ACTIVE' },
  { label: '暂停', value: 'SUSPENDED' },
  { label: '封禁', value: 'BANNED' }
]

const inviteStatusOptions = [
  { label: '未使用', value: 'UNUSED' },
  { label: '已使用', value: 'USED' },
  { label: '已过期', value: 'EXPIRED' }
]

const loading = ref(true)
const list = ref<O2oProviderMerchantRespVO[]>([])
const total = ref(0)
const queryParams = reactive({
  pageNo: 1,
  pageSize: 10,
  realName: undefined as string | undefined,
  mobile: undefined as string | undefined,
  status: undefined as string | undefined
})
const queryFormRef = ref()

const inviteLoading = ref(false)
const inviteList = ref<O2oInviteCodeMerchantRespVO[]>([])
const inviteTotal = ref(0)
const inviteQueryParams = reactive({
  pageNo: 1,
  pageSize: 10,
  status: undefined as string | undefined
})

const detailVisible = ref(false)
const detailLoading = ref(false)
const detail = ref<O2oProviderMerchantRespVO | null>(null)
const detailTitle = computed(() => (detail.value ? `员工详情 - ${detail.value.realName}` : '员工详情'))

const createInviteVisible = ref(false)
const createInviteSubmitting = ref(false)
const createInviteFormRef = ref()
const createInviteForm = reactive({ targetMobile: '' })
const createInviteRules = {
  targetMobile: [
    { required: true, message: '请输入员工手机号', trigger: 'blur' },
    { pattern: /^1\d{10}$/, message: '手机号格式不正确', trigger: 'blur' }
  ]
}

const createdCodeVisible = ref(false)
const createdCode = ref('')

const statusLabel = (s?: string) => statusOptions.find((o) => o.value === s)?.label || s || '—'
const statusTagType = (s?: string) =>
  s === 'ACTIVE' ? 'success' : s === 'SUSPENDED' ? 'warning' : s === 'BANNED' ? 'danger' : 'info'
const inviteStatusLabel = (s?: string) => inviteStatusOptions.find((o) => o.value === s)?.label || s || '—'
const inviteStatusTagType = (s?: string) =>
  s === 'UNUSED' ? 'success' : s === 'USED' ? 'info' : s === 'EXPIRED' ? 'warning' : 'info'
const genderLabel = (g?: number) => (g === 1 ? '男' : g === 0 ? '女' : '—')
const depositLabel = (s?: string) =>
  s === 'PAID' ? '已缴纳' : s === 'REFUNDED' ? '已退还' : s === 'NONE' ? '未缴纳' : s || '—'
const formatDateTime = (v?: string | number | Date) =>
  v != null && v !== '' ? formatDate(v) : '—'

const canToggleStatus = (row: O2oProviderMerchantRespVO) =>
  row.status === 'ACTIVE' || row.status === 'SUSPENDED'

const getList = async () => {
  loading.value = true
  try {
    const data = await getO2oMerchantProviderPage({ ...queryParams })
    list.value = data.list
    total.value = data.total
  } finally {
    loading.value = false
  }
}

const getInviteList = async () => {
  inviteLoading.value = true
  try {
    const data = await getO2oMerchantInviteCodePage({ ...inviteQueryParams })
    inviteList.value = data?.list ?? []
    inviteTotal.value = data?.total ?? 0
  } finally {
    inviteLoading.value = false
  }
}

const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

const handleInviteQuery = () => {
  inviteQueryParams.pageNo = 1
  getInviteList()
}

const resetQuery = () => {
  queryFormRef.value?.resetFields()
  handleQuery()
}

const openDetail = async (id: number) => {
  detailVisible.value = true
  detailLoading.value = true
  detail.value = null
  try {
    detail.value = await getO2oMerchantProvider(id)
  } finally {
    detailLoading.value = false
  }
}

const handleToggleStatus = async (row: O2oProviderMerchantRespVO) => {
  const nextStatus = row.status === 'ACTIVE' ? 'SUSPENDED' : 'ACTIVE'
  const action = nextStatus === 'SUSPENDED' ? '暂停接单' : '恢复接单'
  try {
    await message.confirm(`确认对「${row.realName}」执行${action}？`)
  } catch {
    return
  }
  await updateO2oMerchantProviderStatus({ id: row.id, status: nextStatus })
  message.success(`${action}成功`)
  await getList()
  if (detail.value?.id === row.id) {
    detail.value = await getO2oMerchantProvider(row.id)
  }
}

const openCreateInviteDialog = () => {
  createInviteVisible.value = true
}

const resetCreateInviteForm = () => {
  createInviteForm.targetMobile = ''
  createInviteFormRef.value?.clearValidate()
}

const submitCreateInvite = async () => {
  await createInviteFormRef.value?.validate()
  createInviteSubmitting.value = true
  try {
    const result = await createO2oMerchantInviteCode({ targetMobile: createInviteForm.targetMobile })
    createInviteVisible.value = false
    createdCode.value = result.code
    createdCodeVisible.value = true
    await getInviteList()
  } finally {
    createInviteSubmitting.value = false
  }
}

const copyCode = async (code: string) => {
  try {
    await navigator.clipboard.writeText(code)
    message.success('已复制邀请码')
  } catch {
    message.warning(`请手动复制：${code}`)
  }
}

watch(activeTab, (tab) => {
  if (tab === 'invite' && !inviteList.value.length) {
    getInviteList()
  }
})

onMounted(() => {
  const route = useRoute()
  if (route.query.tab === 'invite') {
    activeTab.value = 'invite'
    getInviteList()
  }
  getList()
})
</script>

<style lang="scss" scoped>
.invite-code {
  font-family: monospace;
  font-weight: 600;
  letter-spacing: 1px;
}

.created-code-box {
  text-align: center;
  padding: 12px 0;
}

.created-code {
  font-size: 32px;
  font-weight: 700;
  letter-spacing: 4px;
  color: var(--el-color-primary);
  margin-bottom: 12px;
}

.created-code-tip {
  font-size: 13px;
  color: var(--el-text-color-secondary);
}

.form-tip {
  margin-top: 4px;
  font-size: 12px;
  color: var(--el-text-color-secondary);
}
</style>
